import { useRef } from 'react';
import gsap from 'gsap';

import { Media as PropsMedia } from '@/models/Props';

import './ImgLazy.scss';

const ImgLazy = ({ src, alt, width }: PropsMedia) => {
    const imgRef = useRef<HTMLImageElement>(null);

    const onImageLoaded = () => {
        gsap.to(imgRef.current, {
            duration: 0.3,
            opacity: 1,
        });
    };

    return (
        <img
            ref={imgRef}
            className={'imgLazy'}
            style={width ? { width: `min(100%, ${width}rem)` } : undefined}
            onLoad={onImageLoaded}
            src={src}
            alt={alt}
        />
    );
};

export default ImgLazy;
